export default [
    // *--------- CONTACT WIRES --------------------------------*
    {
        path: '/railway-structure/contact-wire/list',
        name: 'railway_structure-contact_wire-list',
        component: () => import('@/views/apps/railway_structure/contactWire/views/List.vue'),
        meta: {
            resource: 'contactwire',
            action: 'read',
            pageTitle: 'Контактные провода',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Контактные провода ЖД',
                  active: true,
                },
            ],
        },
    },
    {
        path: '/railway-structure/contact-wire/view/:id',
        name: 'railway_structure-contact_wire-view',
        component: () => import('@/views/apps/railway_structure/contactWire/views/Details.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Контактные провода',
            breadcrumb: [
                {
                    text: 'Структура ЖД',
                    active: true,
                },
                {
                    text: 'Контактные провода',
                    to: {
                        name: 'railway_structure-contact_wire-list',
                    }
                },
                {
                    text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
